/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairEmergencyContactUpdateRequest } from '../../models/finnair-emergency-contact-update-request';

export interface UpdateEmergencyContactDetails$Params {
  orderId: string;
  hash?: string;
  locale?: string;
      body: FinnairEmergencyContactUpdateRequest
}

export function updateEmergencyContactDetails(http: HttpClient, rootUrl: string, params: UpdateEmergencyContactDetails$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, updateEmergencyContactDetails.PATH, 'patch');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

updateEmergencyContactDetails.PATH = '/api/v2/order/{orderId}/emergency-contact';
